export interface UserInterface {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    category?: string;
    createdAt?: any;
    password?: string;
    gender?: GenderEnum;
}

export enum GenderEnum {
    MALE =  'MALE',
    FEMALE = 'FEMALE'
}

export interface UserFirebaseInterface {
    uid: string;
    displayName: string;
    email: string;
    photoURL: string;
}

export interface UserDetailInterface {
    id?: string;
    level: number;
    lastClass: number;
}